import { connect } from 'react-redux'
import React, { useEffect } from 'react'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useJustificativasCargasParadas, {
  LOAD_MESSAGE,
  MENU_ITEMS,
} from './JustificativaCargasParadasHook'
import {
  Btn,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  InputText,
  CustomPanel,
  PageHeader,
  Periodo,
  ThreeDots,
  CustomDataTable
} from '../../../../components'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import { withRouter } from 'react-router'
import EnvioJustificativaCargaParadas from './EnvioJustificativaCargaParadas'
import { Fieldset } from 'primereact/fieldset'

function formatDate(dateStr) {
  if (!dateStr) return ''
  if (/^\d{2}\/\d{2}\/\d{4}( \d{2}:\d{2})?$/.test(String(dateStr))) return dateStr
  const s = String(dateStr).split('T')
  const d = s[0].split('-')
  if (d.length === 3) {
    const [ano, mes, dia] = d
    return `${dia}/${mes}/${ano}`
  }
  return ''
}

function JustificativasCargasParadas({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useJustificativasCargasParadas()

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_INITIAL_INFO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getVeiculosCarregamento(
          selectedTp,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        localDispatch.getMotivosAtraso(selectedTp)
        break

      case LOAD_MESSAGE.GET_DELIVERIES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getVeiculosCarregamento(
          selectedTp,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
        )
        break

      case LOAD_MESSAGE.GET_DELIVERIES_FILTERED:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getVeiculosCarregamento(
          selectedTp,
          state.periodo.dataInicial,
          state.periodo.dataFinal,
          state.selectedCompany.id,
          state.identifier.trim(),
        )
        break

      case LOAD_MESSAGE.SAVE_REASON:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.saveJustifyToDeliveries(selectedTp, state.entregas, state.justifyReason)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    if (state.pathRedirect && state.pathRedirect !== '')
      history.push(state.pathRedirect, {
        cargaParada: state.selectedCargaParada,
      })
  }, [state.pathRedirect])

  return (
    <div>
      <PageHeader>3.16 - Justificativa de Cargas Paradas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div>
            <div className="p-grid">
              <div className="p-col-3">
                <Periodo
                  periodoInicial={state.periodo.dataInicial}
                  periodoFinal={state.periodo.dataFinal}
                  onPesquisar={localDispatch.onPesquisar}
                />
              </div>
            </div>
            <EnvioJustificativaCargaParadas
              onBtnSalvarInfo={justifyReason =>
                localDispatch.onBtnSalvarInfo(justifyReason, state.entregas)
              }
              motivosAtraso={state.motivosAtraso}
              onSelecionarTodos={localDispatch.onSelecionarTodos}
            />
            <Fieldset legend="Filtro" toggleable collapsed={true} style={{ marginTop: 20 }}>
              <div className="p-grid p-align-center">
                <div className="p-col-6">
                  <CustomDropdown
                    label="Empresa"
                    optionLabel="name"
                    options={state.companies}
                    value={state.selectedCompany}
                    onChange={v => localDispatch.onFiltroChange('selectedCompany', v)}
                    placeholder="Selecione"
                  />
                </div>
                <div className="p-col-4">
                  <InputText
                    label="Nota Fiscal"
                    value={state.identifier}
                    onChange={value => localDispatch.onFiltroChange('identifier', value)}
                  />
                </div>
                <div className="p-col-2" style={{ marginTop: 32 }}>
                  <Btn
                    onClick={() =>
                      localDispatch.onBuscarFiltrado(state.selectedCompany, state.identifier)
                    }
                  >
                    Buscar
                  </Btn>
                </div>
              </div>
            </Fieldset>
            <div style={{ marginTop: 20 }}>
              <CustomDataTable
                key={state.tableVersion}
                value={state.entregas}
                header={
                  <CustomDataTableHeader
                    onChange={value => localDispatch.onGlobalFilterChange(value)}
                  />
                }
                globalFilter={state.globalFilter}
                emptyMessage="Não existem veiculos para atribuir as informações "
                paginator={true}
                rows={10}
                style={{ textAlign: 'center' }}
              >
                <Column
                  field="selected"
                  style={tableCellCentered(60)}
                  body={entrega => (
                    <CustomCheckbox
                      checked={entrega.selected}
                      onChange={checked => localDispatch.onCheckBoxRowClicked(entrega, checked)}
                    />
                  )}
                />
                <Column field="identifier" header="Identificador" style={tableCellCentered(150)} />
                <Column field="nome_fantasia" header="Nome Fantasia" />
                <Column field="company_name" header="Empresa" />
                <Column field="city" header="Cidade" />
                <Column field="district" header="Bairro" />
                <Column
                  field="motivo_atraso"
                  style={tableCellCentered(200)}
                  header="Motivo de Atraso"
                />
                <Column
                  field="proxima_data_agendamento"
                  header="Próxima Data Agendamento"
                  style={tableCellCentered(180)}
                  body={cargaParada => formatDate(cargaParada.proxima_data_agendamento)}
                />
                <Column
                  header="Menu"
                  style={{ textAlign: 'center', width: 80 }}
                  body={cargaParada => (
                    <ThreeDots
                      items={MENU_ITEMS}
                      onClick={menuItem => localDispatch.onThreeDotsClicked(menuItem, cargaParada)}
                    />
                  )}
                />
              </CustomDataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
    </div>
  )
}

const mapStateToProp = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProp)(withRouter(JustificativasCargasParadas))
